import { gql } from "@apollo/client";

export const REGISTER = gql`
mutation Register(
  $email: String!, 
  $password: String!, 
  $first_name: String, 
  $last_name: String, 
  $phone: String
) {
    register(
      email: $email, 
      password: $password, 
      first_name: $first_name, 
      last_name: $last_name, 
      phone: $phone
    ) {
        data
        error
        message
        statusCode
    }
}`;
export const LOGIN = gql`
mutation Login ($email: String!, $password: String!) {
  signIn(email:$email,password:$password){
    data
    error
    message
    statusCode
  }
}`;

export const VERIFY_OTP = gql`
mutation verifyEmail($otp: String!, $password: String!, $session_id: String!, $user_id: String!, $type: String!) {
  verifyOtp(otp: $otp, password: $password, session_id: $session_id, user_id: $user_id, type: $type) {
    data
    error
    message
    statusCode
  }
}
`;
export const RESET_PASSWORD_SEND_OTP = gql`
  mutation MyMutation($email: String!) {
    resetPassword(email: $email) {
      data
      error
      statusCode
      message
    }
  }
`;
export const RESET_PASSWORD_VERIFY_OTP = gql`
mutation VerifyOtp($otp: String!, $password: String!, $session_id: String!, $user_id: String!, $type: String!) {
  verifyOtp(otp: $otp, password: $password, session_id: $session_id, user_id: $user_id, type: $type) {
    data
    error
    message
    statusCode
  }
}
`
export const UPDATE_ORG_USERS = gql`
  mutation UpdateOrgUsersByPk($pk_columns: org_users_pk_columns_input!, $_set: org_users_set_input!) {
    update_org_users_by_pk(pk_columns: $pk_columns, _set: $_set) {
      id
      first_name
      last_name
      dob
      profile_pic_url
    }
  }
`;
export const USER_UPLOAD_PROFILE_PIC = gql`
mutation UserUploadProfilePic {
  userUploadProfilePic(content_type: "image/png", type: "profile_picture") {
      data
      error
      message
      statusCode
  }
}


`


export const INSERT_COMMON_ADDRESSES_ONE = gql`

mutation Insert_common_addresses_one($object: common_addresses_insert_input!) {
  insert_common_addresses_one(object: $object) {
    id
  }
}

`;

export const INSERT_BILLING_ADDRESS = gql`
mutation Insert_billing_address($object: common_billing_addresses_insert_input!) {
  insert_common_billing_addresses_one(object: $object) {
    id
  }
}
`;

export const UPDATE_BILLING_ADDRESS = gql`
  mutation Update_billing_address($id: uuid!, $object: common_billing_addresses_set_input!) {
    update_common_billing_addresses(
      where: { id: { _eq: $id } }
      _set: $object
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
export const UPDATE_COMMON_ADDRESS = gql`
  mutation Update_common_addresses_by_pk($id: uuid!, $set: common_addresses_set_input!) {
    update_common_addresses_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;

export const INSERT_REVIEW = gql`
  mutation Insert_product_product_review_one(

    $rating: Int,
    $product_id: uuid!,
    $is_visible: Boolean,
    $description: String
  ) {
    insert_product_product_review_one(
      object: {
 
        rating: $rating
        product_id: $product_id
        is_visible: $is_visible
        description: $description
      }
    ) {
      id
    }
  }
`;

export const UPDATE_PRIMARY_STATUS_ADDRESS = gql`


mutation Update_common_addresses_many($id: uuid!) {
    update_common_addresses_many(
        updates: {
            _set: { is_primary: false }
            where: {
                id: { _neq: $id }
                is_primary: { _eq: true }
                deleted_at: { _is_null: true }
            }
        }
    ) {
        returning {
            id
            is_active
            deleted_at
            is_primary
        }
    }
}
`;
export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      data
      error
      message
      statusCode
    }
  }
`;
export const UPDATE_PAYMENT_STATUS_AND_GATYEWAY = gql`
  mutation UpdateOrderCartsByPk($id: uuid!, $set: order_carts_set_input!) {
    update_order_carts_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      payment_status
      payment_gateway
    }
  }
`;
export const INSERT_CART_META = gql`
mutation InsertOrderCartMeta($object: order_cart_meta_insert_input!) {
  insert_order_cart_meta_one(object: $object) {
    id
    cart_id
  }
}

`
export const UPDATE_CART_META = gql`
mutation UpdateOrderCartMeta($cart_id: uuid!, $set: order_cart_meta_set_input!) {
  update_order_cart_meta(where: { cart_id: { _eq: $cart_id } }, _set: $set) {
    affected_rows
  }
}


`
export const ADD_ENTRY_TO_MAIL_LIST = gql`
mutation InsertTenantMailList($mail: String!) {
  insert_tenant_mail_list(
    objects: {
      mail: $mail
    }
  ) {
    affected_rows
  }
}
`
export const UPDATE_ENTRY_TO_MAIL_LIST = gql`
mutation UpdateTenantMailList(
  $where: tenant_mail_list_bool_exp!
  $_set: tenant_mail_list_set_input!
) {
  update_tenant_mail_list(
    where: $where
    _set: $_set
  ) {
    affected_rows
  }
}
`
export const GET_SHIPPING_RATES = gql`
mutation CalculateShipment(
  $address_id: String!
  $cart_id: String!
  $org_id: String!
  $vendor_id: String!
) {
  calculateShipment(
    address_id: $address_id
    cart_id: $cart_id
    org_id: $org_id
    vendor_id: $vendor_id
  ) {
    message
    data
    error
    statusCode
  }
}

`
export const ADD_VARIANT_SIZES = gql`
  mutation AddVariantSizes($objects: [order_cart_item_sizes_insert_input!]!) {
    insert_order_cart_item_sizes(
      objects: $objects
      on_conflict: {
        constraint: cart_item_sizes_unique
        update_columns: [quantity, metal,plating_id,is_deleted]
      }
    ) {
      affected_rows
      returning {
        id
        cart_item_id
        variant_size_id
        quantity
        metal
        is_deleted
        plating_id
      }
    }
  }
`;

export const UPDATE_CART_ITEM_SIZE_QUANTITY = gql`
  mutation UpdateCartItemSizeQuantity($id: uuid!, $quantity: numeric!, $metal: String!, $plating_id: uuid) {
    update_order_cart_item_sizes_by_pk(
      pk_columns: { id: $id }
      _set: { quantity: $quantity, metal: $metal, plating_id: $plating_id }
    ) {
      id
      quantity
      metal
      plating_id
    }
  }
`;
export const DELETE_CART_ITEM_SIZE_SOFT = gql`
  mutation DeleteCartItemSizeSoft($id: uuid!) {
    update_order_cart_item_sizes_by_pk(
      pk_columns: { id: $id }
      _set: {  is_deleted: true }
    ) {
      id
      variant_size_id
      quantity
      cart_item_id
    }
  }
`;




export const UPDATE_CART = gql`
      mutation updateCart($id: uuid = "", $_set: order_carts_set_input = {}) {
        update_order_carts_by_pk(pk_columns: {id: $id}, _set: $_set) {
          id
          address_id
          shipping_id
          final_amount
          insurance_charge
          gateway_charge
          plating_charge
          status
        }
      }
`
export const UPDATE_CART_ITEM_QUANTITY = gql`
  mutation UpdateCartItemQuantity($id: uuid!, $quantity: Int!) {
    update_order_cart_items_by_pk(
      pk_columns: { id: $id }
      _set: { quantity: $quantity }
    ) {
      id
      quantity
    }
  }
`;

export const SEND_ORDER_EMAIL = gql`
    mutation SendOrderEmail($cart_id: uuid!, $user_id: uuid!) {
      sendOrderEmail(input: { cart_id: $cart_id, user_id: $user_id }) {
          emailSent
          message
      }
    }
  `;
export const FREEZE_STOCK = gql`
  mutation FreezeStock($cart_id: uuid!) {
  freezeStock(cart_id: $cart_id) {
    data
    error
    message
    statusCode
  }
}

  `


export const UPDATE_PAYMENT_LINK_STATUS = gql`
  mutation UpdateOrderPaymentLinks(
  $where: order_payment_links_bool_exp!
  $_set: order_payment_links_set_input!
) {
  update_order_payment_links(
    where: $where
    _set: $_set
  ) {
    affected_rows
  }
}

  `
export const INSERT_CUSTOMER_REVIEW = gql`
mutation InsertProductReview($object: product_product_review_insert_input!) {
  insert_product_product_review_one(object: $object) {
    id
  }
}
  `

  export const ADD_CUSTORMER_QUERY = gql`
  mutation InsertTenantSupport($object: tenant_support_insert_input!) {
  insert_tenant_support_one(object: $object) {
    id
  }
}
  `
    
  export const  ADD_CUSTOMER_ENQUIRY = gql`

mutation InsertTenantEnquiry($object: tenant_enquiry_insert_input!) {
  insert_tenant_enquiry_one(object: $object) {
    id
  }
}
`
export const SEND_ENQUIRY_MAIL = gql`
mutation SendEnquiryMail($email: String!) {
  sendEnquiryMail(email: $email) {
    data
    error
    message
    statusCode
  }
}

`
export const SEND_SUPPORT_MAIL = gql`
mutation SendSupportMail($mail: String!) {
  sendSupportMail(mail: $mail) {
    data
    error
    message
    statusCode
  }
}
`;